import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/system';
import MuiRadio from '@mui/material/Radio';
import { black, blue, red, white } from '@cpg-its/ads.constants.colors';
const StyledRadio = styled(MuiRadio)({
    color: black,
    background: white,
    width: 20,
    height: 20,
    margin: '.625rem .75rem',
    padding: '0 !important',
    '&.Mui-checked': {
        color: blue,
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    '&:hover': {
        backgroundColor: 'transparent',
    },
    '&.error': {
        color: `${red} !important`,
    },
});
export const RadioComponent = ({ beenTouched = false, checked = false, disabled = false, hasError = false, onClick = () => { }, testId = undefined, value, }) => (_jsx(StyledRadio, { className: (hasError && beenTouched ? 'error' : ''), checked: checked, "data-testid": testId, disabled: disabled, onClick: onClick, value: value, disableRipple: true }));
export default RadioComponent;
//# sourceMappingURL=radio.js.map